import { validateItemAuthoring, type AuthoringFindings, type PublishData } from './publish-validation';
export { validateStructuredItemRows } from './structured-item-rows';

/** The existing mode/rules island also carries the raw facts needed by all native callers. */
export function readItemAuthoringData(text: string): PublishData {
    const doc = JSON.parse(text) as Omit<PublishData, 'rules'> & { mode: string; rules: PublishData['rules']['rules'] };
    if (!doc || !Array.isArray(doc.rules) || !doc.catalog || !doc.descent || !Array.isArray(doc.objectTypes)
        || !Array.isArray(doc.aoeTypes) || typeof doc.selfRangeId !== 'string' || typeof doc.bodyEssenceId !== 'string')
        throw new Error('Authoring data unavailable. Reload the editor and retry.');
    return { ...doc, rules: { mode: doc.mode, rules: doc.rules } };
}

export function validateItemSave(data: Record<string, unknown>, facts: PublishData): AuthoringFindings {
    return validateItemAuthoring(data, facts, [1, '1', true, 'on'].includes(data.ignore_requirements as string | number | boolean) ? 'draft' : 'final');
}
